import React from "react"

const year = new Date().getFullYear()

const Tail = () => {

    return (
        <div>
            <p>© {year}. All Rights Reserved | AS Sleep Makers.</p>
            Payments Partner : <img src="/razor-pay-logo.svg" alt="razorpay" /> | Sales Partner : <img style={{ height: "24px" }} src="/images/logos/Amazon_logo.png" alt="amazon" />
        </div>
    )
}

export default Tail